module.exports = __webpack_public_path__ + "static/4-3cf17253655f15fcd8e13db5f96848d5.png";